import dynamic from 'next/dynamic';
import React from 'react'

const DynamicOpenFavourites = dynamic(() => import("./OpenFavourites"), {
  ssr: false,
});

const FavoriteList = ({ favorites, refTwo, showFavorites, setShowFavorites }) => {
  return (
    <div
      ref={refTwo}
      className={
        "fixed flex-col flex right-0 top-0 bg-white shadow-lg w-72 rounded-sm h-screen px-3 py-5 overflow-y-auto z-[55] transition-all transform-gpu " +
        (showFavorites ? "translate-x-0 " : "translate-x-full ")
      }
    >
      <div className="flex items-center justify-between mb-3">
        <strong className="inline-block text-lg">Favori Listesi</strong>
        <button
          onClick={() => setShowFavorites(false)}
          className={`text-xs py-1 px-2 rounded bg-themeSecondColor text-white`}
        >
          Kapat
        </button>
      </div>
      {favorites?.length === 0 && (
        <div
          className="p-3 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
          role="alert"
        >
          <span className="font-medium">
            Favori listenizde herhangi bir ürün bulunmamaktadır.
          </span>
        </div>
      )}
      {showFavorites && favorites?.map((villa) => {
        return (
          <DynamicOpenFavourites
            key={villa.id}
            villa={villa}
            setShowFavorites={setShowFavorites}
          />
        );
      })}
    </div>
  );
}

export default FavoriteList